import { useState } from 'react';
import AddToFolderButton from '../../../../../../common/folders/add-to-folder-button/add-to-folder-button';
import { FOLDER_DIRECTORIES } from '../../../../../../constants/folder';
import translation from '../../../../../../languages';
import { OverlayTrigger } from '../../../../../../ui/overlay-trigger/overlay-trigger';
import Tooltip from '../../../../../../ui/tooltip';

type AddToFolderIconButtonProps = TranslationProps & { item: Material };

const AddToFolderIconButton = ({ t, item }: AddToFolderIconButtonProps) => {
    const [shouldShowIconTooltip, setShouldShowIconTooltip] = useState<boolean>(false);

    const handleShowFolderTooltip = (): void => setShouldShowIconTooltip(true);
    const handleCloseFolderTooltip = (): void => setShouldShowIconTooltip(false);

    return (
        <OverlayTrigger
            overlay={
                <Tooltip.Simple id='add-to-folder-icon-button-tooltip'>
                    {t('modals.addToFolderModal.title')}
                </Tooltip.Simple>
            }
            placement='top'
            trigger={['focus', 'hover']}
            show={shouldShowIconTooltip}
        >
            <span className='folder-button-wrapper'>
                <AddToFolderButton
                    directory={FOLDER_DIRECTORIES.WISHLIST}
                    items={[item]}
                    onMouseEnter={handleShowFolderTooltip}
                    onMouseLeave={handleCloseFolderTooltip}
                />
            </span>
        </OverlayTrigger>
    );
};

const translate = translation('modals');

export default translate(AddToFolderIconButton);
